<template>
  <delete-box
    class="pad-top"
    :text="text"
    loaderText="Deleting Analytic"
    :showLoader="showLoader">
      <a v-on:click="submit" class="add button level-item">
        <i class="far fa-save"></i>
        Delete Analytic
      </a>
    </delete-box>
</template>

<script>
import DeleteBox from '@/components/DeleteBox.vue';

export default {
  name: 'AnalyticDelete',
  components: { DeleteBox },
  props: {
    analytic: {
      type: Object,
      required: true,
    },
    admin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showLoader: false,
    };
  },
  computed: {
    endpoint() {
      if (this.admin) {
        return 'admin/deleteAnalytic';
      }
      return 'primary/deleteAnalytic';
    },
    redirect() {
      if (this.admin) {
        return 'admin.analytics.index';
      }
      return 'analytics.index';
    },
    text() {
      if (this.admin) {
        return 'This will removed the analytic from all organizations. Are you sure you want to delete this analytic?';
      }
      return 'Are you sure you want to delete this analytic?';
    },
  },
  methods: {
    async submit() {
      this.showLoader = true;
      const analytic = await this.$store.dispatch(this.endpoint, { uuid: this.analytic.uuid });
      this.showLoader = false;
      if (analytic) {
        this.$router.push({ name: this.redirect });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.pad-top {
  margin-top: $content-padding;
}
</style>
